<template>
  <CardContainer>
    <div
      :class="{'rounded-b-lg': !isExpanded, 'bg-offWhite': isExpanded}"
      class="p-sm rounded-t-lg border-solid border-0 border-b-1 border-border text-black"
    >
      <div class="flex gap-sm">
        <div class="flex-1 self-center">
          <p
            class="ml-sm mb-0"
            :class="{'font-bold ': isExpanded}"
          >{{ $t('ui.envelopes.create.steps.summary.parties.partyTitle', { index: party.order + 1, name: party.title }) }}</p>
        </div>
        <div class="flex items-center">
          <BaseButton
            @click.native="isExpanded = !isExpanded"
            data-test="expand-button"
            variant="invisible"
            size="small"
            class="!px-sm"
            :aria-pressed="isExpanded"
            data-ec="envelopes_summary_page"
            data-et="expand_party_information_button"
          >
            <span class="hidden md:inline-block">
              {{ isExpanded ? $t('ui.envelopes.create.steps.summary.parties.collapse') : $t('ui.envelopes.create.steps.summary.parties.expand')}}
            </span>

            <ChevronUpIcon
              class="transition-all duration-200 ml-base"
              :class="{ 'rotate-180': !isExpanded }"
              aria-hidden="true"
            />
          </BaseButton>
        </div>
      </div>
    </div>
    <div
      v-if="isExpanded"
      class="bg-whiteOverride rounded-b-lg"
      data-test="party-content"
    >
      <div class="p-base pl-md">
        <p class="font-bold text-14 text-black mb-0">
          {{ $t('ui.envelopes.create.steps.summary.parties.nameRole') }}
        </p>
        <p class="font-normal flex items-center mb-0 break-all">
          {{ party.title }} ({{ party.email }}) | {{ $t(`ui.envelopes.create.steps.summary.parties.roles.${party.role}`) }}
        </p>
      </div>
      <div
        v-if="party.password"
        data-test="party-password-section"
      >
        <hr class="m-0"/>
        <div class="p-base pl-md">
          <p class="font-bold text-14 text-black mb-0">
            {{ $t('ui.envelopes.create.steps.summary.parties.password') }}
          </p>
          <div class="flex flex-wrap items-center gap-sm">
            <p
              v-if="revealPassword"
              class="font-normal flex items-center mb-0"
              data-test="party-password"
            >
              {{ party.password }}
            </p>
            <p
              v-else
              class="font-normal flex items-center mb-0"
              data-test="party-password-placeholder"
            >
              <PasswordPlaceholderIcon class="text-black" />
            </p>
            <div class="flex items-center">
              <button
                @click="revealPassword = !revealPassword"
                type="button"
                class="bg-transparent border-none w-fit cursor-pointer text-signableBrandColours-darkGrey hover:text-signableBrandColours-black active:text-signableBrandColours-darkGrey"
                data-test="reveal-password-button"
                :aria-label="$t('forms.floatingLabelInput.revealPassword')"
                :aria-pressed="revealPassword"
              >
                <EyeIcon
                  aria-hidden="true"
                  class="cursor-pointer"
                />
              </button>
              <CopyToClipboardControl
                class="ml-xs"
                :target="party.password"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="party.message"
        data-test="party-message-section"
      >
        <hr class="m-0"/>
        <div class="p-base pl-md">
          <p class="font-bold text-14 text-black mb-0">
            {{ $t('ui.envelopes.create.steps.summary.parties.personalMessage') }}
          </p>
          <p class="font-normal flex items-center mb-0">
            {{ party.message }}
          </p>
        </div>
      </div>
    </div>
  </CardContainer>
</template>

<script>
import { defineComponent, ref } from 'vue';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import { ChevronUpIcon } from '@/components/library/icons';
import { EyeIcon } from '@/components/icons/fontIcons';
import CopyToClipboardControl
  from '@/components/ui/envelopeCreate/steps/addRecipients/passwordTab/CopyToClipboardControl/CopyToClipboardControl.vue';
import { CardContainer } from '@/components/library/containers';
import PasswordPlaceholderIcon from '@/components/icons/PasswordPlaceholderIcon/PasswordPlaceholderIcon.vue';

export default defineComponent({
  name: 'PartySummaryCard',
  components: {
    PasswordPlaceholderIcon,
    CardContainer,
    CopyToClipboardControl,
    EyeIcon,
    BaseButton,
    ChevronUpIcon,
  },
  props: {
    party: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const revealPassword = ref(false);
    const isExpanded = ref(false);

    return {
      revealPassword,
      isExpanded,
    };
  },
});
</script>
